import { SharedContext } from '@/domain/dienstplan/features/VisualEditor/hooks/useVisualEditor/types';
import { Point } from '@/domain/dienstplan/features/VisualEditor/types';
import { snapToQuarterHour } from '@/domain/dienstplan/features/VisualEditor/utils/mouseHelper/snapToQuarterHour';

export function getSnappedMousePosition(ctx: SharedContext, point: Point) {
  return {
    x: snapToQuarterHour(ctx.xScalePoint.invert(point.x)),
    y: Math.round(ctx.yScalePoint.invert(point.y)),
  };
}
